import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation MFAValidate($code: String!) {
    mfaValidate(code: $code) {
      success
      accessToken
    }
  }
`

export const mfaValidateKey = getQueryNames(mutation)[0]

export default mutation
